
import Vue, { PropType } from 'vue'
import { Multimedia } from '@/model/Multimedia'

export default Vue.extend({
  name: 'Multimedia',
  props: {
    multimedia: {
      type: Object as PropType<Multimedia>,
      default: null
    },
    width: {
      type: [String, Number],
    },
    height: {
      type: [String, Number],
    },
    maxWidth: {
      type: [String, Number],
    },
    maxHeight: {
      type: [String, Number],
    },
    aspectRatio: {
      type: [String, Number],
    },
    size: {
      type: String,
      default: 'size4',
    },
    contain: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    safeSrc(): any {
      if (!this.multimedia || !this.multimedia.url) {
        return require('@/assets/default-image.png');
      }

      if(process.env.VUE_APP_FILE_STRATEGY === 'local'){
        return process.env.VUE_APP_TECH_MASTER_EVENT_API_HOST + this.multimedia.url;
      } else {
        return 'https://' + this.multimedia.url;
      }
    },

    safeAlt(): string {
      return this.multimedia?.alt || 'multimedia';
    },
    position: function (): string {
      return 'center center'
    },
  },
  data: () => ({}),
})
